import Button, { type ButtonProps } from '@mui/material/Button';
import { useMobileLayout } from '../utils';

export interface StandardButtonProps extends ButtonProps {
  text?: string;
  width?: string;
  noFocus?: boolean;
}

export const linkButtonNoFocusProps = {
  component: 'div' as const,
  role: 'none',
  tabIndex: -1,
};

export const StandardButton = ({
  text,
  children,
  sx,
  width,
  noFocus,
  ...props
}: StandardButtonProps) => {
  const isMobile = useMobileLayout();

  return (
    <Button
      sx={{
        flex: 'none',
        width: isMobile ? '100%' : 'auto',
        whiteSpace: 'nowrap',
        ...sx,
      }}
      {...(noFocus ? linkButtonNoFocusProps : {})}
      {...props}
    >
      {children || text}
    </Button>
  );
};

export default StandardButton;
